'use client';

import {
  Dialog,
  DialogActionButton,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

interface BlockConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function BlockConfirmModal({ open, onOpenChange, onConfirm }: BlockConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='!max-w-[400px]'>
        <DialogHeader>
          <DialogTitle>Block this player?</DialogTitle>
          <DialogSubTitle>
            Blocking this player will prevent them from viewing your profile or interacting with
            you. You can unblock them at any time on this tab.
          </DialogSubTitle>
        </DialogHeader>
        <DialogFooter>
          <DialogCloseButton>Cancel</DialogCloseButton>
          <DialogActionButton onClick={onConfirm}>Confirm</DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
